/* eslint-disable */
/* This file was automatically generated and should not be edited manually. */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string | Date; output: any; }
  YearMonth: { input: unknown; output: unknown; }
};

export type Aps = {
  __typename?: 'Aps';
  helpUrl: Scalars['String']['output'];
  medicalInstitutionInfoChangeUrl: Scalars['String']['output'];
  paymentManagementLoginUrl: Scalars['String']['output'];
  prescriptionHelpUrl: Scalars['String']['output'];
};

export type ApsError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ApsInternalError = ApsError & {
  __typename?: 'ApsInternalError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type BillableEvent = {
  __typename?: 'BillableEvent';
  billableStatus: BillableStatus;
  createdAt: Scalars['Date']['output'];
  executer?: Maybe<MedicalInstitutionMember>;
  id: Scalars['ID']['output'];
  prescriptionEvent?: Maybe<PrescriptionEvent>;
};

export enum BillableStatus {
  Billable = 'BILLABLE',
  Nonbillable = 'NONBILLABLE'
}

export type BillingAccount = {
  __typename?: 'BillingAccount';
  billingAccountId: Scalars['String']['output'];
  /** 決済担当者（一元化された連絡先）。HubSpot 連携前は null */
  contact?: Maybe<EmailContact>;
  contactEmailAddress: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** 請求書の送付方法。sendMail / sendEmail がいずれも false の場合は null */
  invoiceDeliveryMethod?: Maybe<InvoiceDeliveryMethod>;
  medicalInstitutionId: Scalars['String']['output'];
  /** 決済メール通知先（0〜N名） */
  notificationRecipients: Array<EmailContact>;
  sendEmail: Scalars['Boolean']['output'];
  sendMail: Scalars['Boolean']['output'];
};

export enum BillingAggregationPeriod {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY'
}

export enum BillingCategory {
  CureappHt = 'CUREAPP_HT',
  CureappSc = 'CUREAPP_SC',
  Others = 'OTHERS',
  Relivion = 'RELIVION'
}

export enum BillingConfirmationStatus {
  /** 確認期間内の担当契約で、すべて確認済みの場合 */
  Confirmed = 'CONFIRMED',
  /** 確認期間内の担当契約で、一つでも未確認の契約がある場合 */
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  /**
   * 以下のいずれかの理由で確認が不要な場合:
   * - 確認期間内の担当契約がない
   * - 確認期間内の担当契約すべてで利用実績が0件
   */
  NotRequired = 'NOT_REQUIRED'
}

export type BillingFile = {
  __typename?: 'BillingFile';
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  month: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type BillingFiles = {
  __typename?: 'BillingFiles';
  deliveryStatement?: Maybe<BillingFile>;
  invoice?: Maybe<BillingFile>;
};

export type BillingMonthlySummary = {
  __typename?: 'BillingMonthlySummary';
  pdtMonthlySummaries: Array<PdtBillingMonthlySummary>;
  rentalDevices: Array<RentalDeviceBillingMonthlySummary>;
};

export type BillingSchedule = {
  __typename?: 'BillingSchedule';
  billableEvents: Array<BillableEvent>;
  billableStatus: BillableStatus;
  billingFixedDate: Scalars['Date']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isBillingRequested: Scalars['Boolean']['output'];
  isBillingSettled: Scalars['Boolean']['output'];
  lastAppliedMedicalGuideEvent?: Maybe<PrescriptionMedicalGuideEvent>;
  month: Scalars['Int']['output'];
  seq: Scalars['Int']['output'];
  status?: Maybe<PrescriptionStatus>;
  unitAmount?: Maybe<UnitAmount>;
  year: Scalars['Int']['output'];
};

/**
 * Filter for billing schedules.
 * If start is not specified, you can get schedules from the beginning.
 * If end is not specified, you can get schedules until the latest.
 * If start = end, you can get a schedule for the specified month.
 * If start > end, you can get no schedules.
 * If you not specify start and end, you can get schedules from the beginning until the latest.
 *
 * If you specify billableStatuses, you can get schedules with the specified billable statuses.
 * If you not specify billableStatuses, you can get schedules with all billable statuses.
 */
export type BillingScheduleFilter = {
  billableStatuses?: InputMaybe<Array<BillableStatus>>;
  end?: InputMaybe<Scalars['YearMonth']['input']>;
  start?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type BillingScheduleFilterInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type BillingScheduleFilterTermInput = {
  end?: InputMaybe<Scalars['YearMonth']['input']>;
  start?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type CancelReservedSenteiRyoyoError = {
  __typename?: 'CancelReservedSenteiRyoyoError';
  code: SenteiRyoyoErrorCode;
  message: Scalars['String']['output'];
};

export enum CancelStatus {
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

export type ClientCertificate = {
  __typename?: 'ClientCertificate';
  createdAt: Scalars['Date']['output'];
  domain: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  medicalInstitution: MedicalInstitution;
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  pfx?: Maybe<Scalars['String']['output']>;
  s3BucketKey?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** 規約同意状態 */
export enum ConsentStatus {
  /** 同意済み */
  Consented = 'CONSENTED',
  /** 未同意 */
  Pending = 'PENDING'
}

export type Contract = {
  __typename?: 'Contract';
  /** 決済担当者 */
  billingAccount?: Maybe<ContractBillingAccount>;
  /**
   * 利用実績の確認期間中はtrueを返す
   * 利用実績を確認済でもtrueを返す
   * @deprecated Will be removed in Phase 2(デプロイ時にアプリケーションが落ちるのを防ぐため2026-1-27リリース予定で削除する).
   */
  billingConfirmationPeriod?: Maybe<Scalars['Boolean']['output']>;
  billingReport?: Maybe<ContractBillingReport>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deliveryOrders?: Maybe<DeliveryOrdersPayload>;
  id: Scalars['ID']['output'];
  initial?: Maybe<Scalars['Boolean']['output']>;
  /** 直近の資材の配送先の住所 */
  latestMaterialOrderedAddress?: Maybe<DeliveryAddress>;
  lendingRentalProductDetails?: Maybe<Array<RentalProduct>>;
  lendingRentalProducts?: Maybe<Array<LendingRentalProduct>>;
  /**
   * 製品管理責任者
   * @deprecated 将来的に削除する予定、responsiblePersonを代わりに使用する
   */
  manager?: Maybe<ContractManager>;
  /** 連絡通知先 */
  notificationRecipients?: Maybe<Array<ContractNotificationRecipient>>;
  pdt: Pdt;
  pdtSiteUrl: Scalars['String']['output'];
  /** PDT規約同意済みかどうか */
  pdtTermsConsented?: Maybe<Scalars['Boolean']['output']>;
  /** 手動制限中かどうか */
  prescriptionRestricted: Scalars['Boolean']['output'];
  /** 製品管理責任者 */
  responsiblePerson?: Maybe<ContractResponsiblePerson>;
  senteiRyoyo?: Maybe<SenteiRyoyoContract>;
  suspensionDays: Scalars['Int']['output'];
  unitAmountTable?: Maybe<Array<UnitAmount>>;
  /**
   * 医療機関が契約しているPDTの締め日(締め日 < 現在時刻)の-1秒の日付を返す(-1秒はフロントで表示する場合を考慮)
   * HTの場合、11日が締め日なので10日23時59秒. UTCの時刻、表記で返す.
   */
  upcomingClosingDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  wholesaler?: Maybe<Scalars['String']['output']>;
};


export type ContractBillingReportArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type ContractDeliveryOrdersArgs = {
  input?: InputMaybe<DeliveryOrderQueryInput>;
};

export type ContractBillingAccount = {
  __typename?: 'ContractBillingAccount';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendMail?: Maybe<Scalars['Boolean']['output']>;
};

export type ContractBillingReport = {
  __typename?: 'ContractBillingReport';
  /** @deprecated Will be removed in Phase 2(2026-01-27リリース). */
  billingConfirmationRequired: Scalars['Boolean']['output'];
  closingDate?: Maybe<Scalars['Date']['output']>;
  confirmationExpired: Scalars['Boolean']['output'];
  /** 確認レコードが存在し、confirmed=trueの場合にtrue */
  confirmed: Scalars['Boolean']['output'];
  /** @deprecated This field is for development purposes only */
  contractBillingConfirmationId?: Maybe<Scalars['ID']['output']>;
  guideOffCount: Scalars['Int']['output'];
  guideOnCount: Scalars['Int']['output'];
  /** 利用実績が存在するかどうか（利用実績が1件以上ある場合にtrue） */
  hasBillingRecords: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<ContractBillingReportItem>;
  operatedAt?: Maybe<Scalars['Date']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
  yearMonth: Scalars['YearMonth']['output'];
};


export type ContractBillingReportItemsArgs = {
  input?: InputMaybe<ContractBillingReportItemQueryInput>;
};

export type ContractBillingReportItem = {
  __typename?: 'ContractBillingReportItem';
  billingSchedule: BillingSchedule;
  id: Scalars['ID']['output'];
  prescription: Prescription;
};

export enum ContractBillingReportItemOrderField {
  BillableStatus = 'BILLABLE_STATUS',
  DisplayRank = 'DISPLAY_RANK',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  PrescriptionKarteNumber = 'PRESCRIPTION_KARTE_NUMBER',
  PrescriptionStatus = 'PRESCRIPTION_STATUS'
}

export type ContractBillingReportItemOrderInput = {
  field: ContractBillingReportItemOrderField;
  value: QueryOrderValue;
};

export type ContractBillingReportItemQueryInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ContractBillingReportItemOrderInput>;
};

export type ContractManager = {
  __typename?: 'ContractManager';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  welcomeMailSentAt?: Maybe<Scalars['Date']['output']>;
};

/** 連絡通知先 */
export type ContractNotificationRecipient = {
  __typename?: 'ContractNotificationRecipient';
  emailContact: EmailContact;
  id: Scalars['ID']['output'];
};

/** 製品管理責任者 */
export type ContractResponsiblePerson = {
  __typename?: 'ContractResponsiblePerson';
  emailContact: EmailContact;
  id: Scalars['ID']['output'];
  welcomeMailSentAt?: Maybe<Scalars['Date']['output']>;
};

export type CreateShippingRequestPayload = ApsInternalError | EmptyUnshippedDeliveryOrderError | ShippingRequestFile;

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city: Scalars['String']['output'];
  isMedicalInstitutionAddress?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  otherAddress: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  prefectureId: Scalars['Int']['output'];
};

export type DeliveryCompany = {
  __typename?: 'DeliveryCompany';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DeliveryContract = {
  __typename?: 'DeliveryContract';
  deliveryCompany?: Maybe<DeliveryCompany>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  vendor?: Maybe<Vendor>;
};

/** 配送基盤の配送履歴（詳細） */
export type DeliveryHistory = {
  __typename?: 'DeliveryHistory';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  outputAt?: Maybe<Scalars['Date']['output']>;
  product: FoundationProduct;
  quantity?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shipConfirmedAt?: Maybe<Scalars['Date']['output']>;
  slipNumber?: Maybe<Scalars['String']['output']>;
  slipSeq?: Maybe<Scalars['Int']['output']>;
};

/** 配送基盤の配送履歴（一覧）。一覧では日付を取得しない */
export type DeliveryHistorySummary = {
  __typename?: 'DeliveryHistorySummary';
  id: Scalars['ID']['output'];
  product: FoundationProduct;
  quantity?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  slipNumber?: Maybe<Scalars['String']['output']>;
  slipSeq?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deliveryContract?: Maybe<DeliveryContract>;
  deliveryProducts?: Maybe<Array<DeliveryProduct>>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  isShippingRequested?: Maybe<Scalars['Boolean']['output']>;
  medicalInstitution?: Maybe<MedicalInstitution>;
  name: Scalars['String']['output'];
  orderClass?: Maybe<OrderClass>;
  orderType: OrderTypeEnum;
  otherAddress?: Maybe<Scalars['String']['output']>;
  pdt?: Maybe<Pdt>;
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  prefectureId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DeliveryOrderFilterInput = {
  orderType?: InputMaybe<OrderTypeEnum>;
};

export type DeliveryOrderQueryInput = {
  filter?: InputMaybe<DeliveryOrderFilterInput>;
  numberPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DeliveryOrderQuerySortInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeliveryOrderQuerySortField {
  OrderedDate = 'OrderedDate'
}

export type DeliveryOrderQuerySortInput = {
  field: DeliveryOrderQuerySortField;
  value: QueryOrderValue;
};

export type DeliveryOrdersPayload = {
  __typename?: 'DeliveryOrdersPayload';
  edges: Array<DeliveryOrder>;
  pageCount: Scalars['Int']['output'];
};

export type DeliveryProduct = {
  __typename?: 'DeliveryProduct';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DeliveryStatus = {
  __typename?: 'DeliveryStatus';
  code: DeliveryStatusCode;
};

export enum DeliveryStatusCode {
  Shipped = 'SHIPPED',
  ShippingRequest = 'SHIPPING_REQUEST',
  Unshipped = 'UNSHIPPED'
}

export type DeliveryStatusError = {
  __typename?: 'DeliveryStatusError';
  code: DeliveryStatusErrorCode;
  message: Scalars['String']['output'];
};

export enum DeliveryStatusErrorCode {
  AlreadyShipped = 'AlreadyShipped',
  CannotCancel = 'CannotCancel',
  CannotEdit = 'CannotEdit'
}

export type DeliveryTime = {
  __typename?: 'DeliveryTime';
  code: DeliveryTimeCode;
  section: Scalars['String']['output'];
};

export enum DeliveryTimeCode {
  Yt0000 = 'YT0000',
  Yt0812 = 'YT0812',
  Yt1416 = 'YT1416',
  Yt1618 = 'YT1618',
  Yt1820 = 'YT1820',
  Yt2021 = 'YT2021'
}

/** 電子カルテの連携用トークン */
export type EmrIntegrationToken = {
  __typename?: 'EMRIntegrationToken';
  emr: EmrType;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type EmrIntegrationViewer = {
  __typename?: 'EMRIntegrationViewer';
  id: Scalars['ID']['output'];
  medicalInstitution?: Maybe<MedicalInstitution>;
  medicalInstitutionMember?: Maybe<MedicalInstitutionMember>;
};

/** 電子カルテの患者情報 */
export type EmrPatient = {
  __typename?: 'EMRPatient';
  birthday?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patientCode: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  tenantId: Scalars['ID']['output'];
};

/** 電子カルテの種別 */
export enum EmrType {
  Medicom = 'MEDICOM'
}

/** 通知先 */
export type EmailContact = {
  __typename?: 'EmailContact';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EmptyUnshippedDeliveryOrderError = ApsError & {
  __typename?: 'EmptyUnshippedDeliveryOrderError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** 配送基盤の配送注文（詳細） */
export type FoundationDeliveryOrder = {
  __typename?: 'FoundationDeliveryOrder';
  address: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  deliveryHistories: Array<DeliveryHistory>;
  deliveryProducts: Array<FoundationDeliveryProduct>;
  deliveryStatus: DeliveryStatus;
  deliveryTime: DeliveryTime;
  id: Scalars['ID']['output'];
  isDummy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderClass: OrderClass;
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  receiptClass: ReceiptClass;
  updatedAt: Scalars['Date']['output'];
};

/**
 * 配送基盤の配送注文（一覧）。一覧では配送履歴の日付を取得しないため、
 * DeliveryHistorySummary を参照する
 */
export type FoundationDeliveryOrderSummary = {
  __typename?: 'FoundationDeliveryOrderSummary';
  address: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  deliveryHistories: Array<DeliveryHistorySummary>;
  deliveryProducts: Array<FoundationDeliveryProduct>;
  deliveryStatus: DeliveryStatus;
  deliveryTime: DeliveryTime;
  id: Scalars['ID']['output'];
  isDummy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderClass: OrderClass;
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  receiptClass: ReceiptClass;
  updatedAt: Scalars['Date']['output'];
};

/** 配送基盤の配送物品（配送基盤が返すフィールドのみを持つ） */
export type FoundationDeliveryProduct = {
  __typename?: 'FoundationDeliveryProduct';
  collective: Scalars['Boolean']['output'];
  product: FoundationProduct;
  quantity: Scalars['Int']['output'];
  returnQuantity: Scalars['Int']['output'];
};

/** 配送基盤の物品（配送基盤が返すフィールドのみを持つ） */
export type FoundationProduct = {
  __typename?: 'FoundationProduct';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unitSize: Scalars['Int']['output'];
};

/** 請求書の送付方法 */
export enum InvoiceDeliveryMethod {
  /** メール */
  Email = 'EMAIL',
  /** メールおよび郵送 */
  EmailAndMail = 'EMAIL_AND_MAIL',
  /** 郵送 */
  Mail = 'MAIL'
}

export type LendingRentalProduct = {
  __typename?: 'LendingRentalProduct';
  product: Product;
  quantity: Scalars['Int']['output'];
};

export type MedicalInstitution = {
  __typename?: 'MedicalInstitution';
  /** APS規約同意済みかどうか */
  apsTermsConsented?: Maybe<Scalars['Boolean']['output']>;
  /** 医療機関の請求先 */
  billingAccount?: Maybe<BillingAccount>;
  /** 確認期間内の担当契約で、一つでも確認が必要な契約がある場合にtrue */
  billingConfirmationNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** 確認期間中（締め日前）かどうか */
  billingConfirmationPeriod?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 医療機関の請求確認ステータス
   * @deprecated Will be removed in Phase 2(デプロイ時にアプリケーションが落ちるのを防ぐため2026-1-27リリース予定で削除する).
   */
  billingConfirmationStatus?: Maybe<BillingConfirmationStatus>;
  canPrescribe: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  forPlayground: Scalars['Boolean']['output'];
  /** 確認期間内の担当契約で、利用実績が1件以上ある場合にtrue */
  hasBillingRecords?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insuranceMedicalInstitutionNo?: Maybe<Scalars['String']['output']>;
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  otherAddress: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  prefectureId: Scalars['Int']['output'];
  prescriptionInputConfiguration: PrescriptionInputConfiguration;
  /** 手動制限中かどうか */
  prescriptionRestricted: Scalars['Boolean']['output'];
  /**
   * 医療機関が契約しているPDTの締め日(締め日 < 現在時刻)の-1秒の日付を返す(-1秒はフロントで表示する場合を考慮)
   * HTの場合、11日が締め日なので10日23時59秒. UTCの時刻、表記で返す.
   */
  upcomingClosingDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** 医療機関による規約への同意記録 */
export type MedicalInstitutionConsent = {
  __typename?: 'MedicalInstitutionConsent';
  consentedAt: Scalars['Date']['output'];
  consentedByMemberId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  medicalInstitutionId: Scalars['ID']['output'];
  termsVersionId: Scalars['ID']['output'];
};

export type MedicalInstitutionMember = {
  __typename?: 'MedicalInstitutionMember';
  contracts?: Maybe<Array<MemberContract>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  licenseRequestForms: Array<PdtLicenseRequestForm>;
  licenses: Array<PdtLicense>;
  name: Scalars['String']['output'];
  position: Array<MedicalInstitutionMemberPosition>;
  role: Array<MedicalInstitutionMemberRole>;
  sex: Sex;
  status: MedicalInstitutionMemberStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum MedicalInstitutionMemberPosition {
  Doctor = 'DOCTOR',
  Nurse = 'NURSE',
  Staff = 'STAFF'
}

export enum MedicalInstitutionMemberRole {
  Admin = 'ADMIN',
  Staff = 'STAFF'
}

export enum MedicalInstitutionMemberStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Invited = 'INVITED',
  SecretcodeReissued = 'SECRETCODE_REISSUED'
}

export type MemberContract = {
  __typename?: 'MemberContract';
  id: Scalars['ID']['output'];
  pdt: MemberPdt;
  pdtSiteUrl: Scalars['String']['output'];
  /** PDT規約同意済みかどうか */
  pdtTermsConsented?: Maybe<Scalars['Boolean']['output']>;
  /** 手動制限中かどうか */
  prescriptionRestricted: Scalars['Boolean']['output'];
  status?: Maybe<MemberContractStatus>;
};

export enum MemberContractStatus {
  Available = 'AVAILABLE',
  NeedConfirmation = 'NEED_CONFIRMATION'
}

export type MemberPdt = {
  __typename?: 'MemberPdt';
  category?: Maybe<Scalars['String']['output']>;
  /** 注意文（Markdown、未設定なら null） */
  caution?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  iconPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDiscontinued: Scalars['Boolean']['output'];
  licenseRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  needDeliveryAddressForPrescription: Scalars['Boolean']['output'];
  /** 短い説明文（未設定なら null） */
  shortDescription?: Maybe<Scalars['String']['output']>;
  supportUrl?: Maybe<Scalars['String']['output']>;
};

export type MessagePayload = {
  __typename?: 'MessagePayload';
  message: Scalars['String']['output'];
};

export type MonthlyBillingFile = {
  __typename?: 'MonthlyBillingFile';
  billingFiles: BillingFiles;
  month: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createShippingRequest: CreateShippingRequestPayload;
};

/**
 * PRESCRIPTION_NOT_FOUND： 処方が存在しない
 * PRESCRIPTION_NOT_ACTIVATED： 処方がアクティベートされていない
 * PRESCRIPTION_CODE_NOT_FOUND： 処方コードが存在しない
 * PRESCRIPTION_PDT_UNSUPPORTED： 処方のPDTが対応していない（現状対応しているのはHTのみ）
 * INTERNAL_ERROR： 内部エラー（DB書き込み失敗を含む）
 */
export enum NextAppPostExpiryErrorType {
  InternalError = 'INTERNAL_ERROR',
  PrescriptionCodeNotFound = 'PRESCRIPTION_CODE_NOT_FOUND',
  PrescriptionNotActivated = 'PRESCRIPTION_NOT_ACTIVATED',
  PrescriptionNotFound = 'PRESCRIPTION_NOT_FOUND',
  PrescriptionPdtUnsupported = 'PRESCRIPTION_PDT_UNSUPPORTED'
}

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  startFrom: Scalars['Date']['output'];
  /**
   * 規約同意お知らせの場合の規約バージョン
   * 通常のお知らせの場合はnull
   */
  termsVersion?: Maybe<NotificationTermsVersion>;
  title: Scalars['String']['output'];
  viewed: Scalars['Boolean']['output'];
};

/** お知らせに紐づく規約バージョン情報 */
export type NotificationTermsVersion = {
  __typename?: 'NotificationTermsVersion';
  /**
   * 規約への同意が可能かどうか
   * 管理者かつ（PDT規約の場合は、そのPDTを担当している場合）にTRUEになる
   */
  canConsentToTerms: Scalars['Boolean']['output'];
  /** 医療機関の同意状態（リゾルバでコンテキストから判定） */
  consentStatus: ConsentStatus;
  /** 改定日 */
  effectiveAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type NotificationToast = {
  __typename?: 'NotificationToast';
  body?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['Date']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  medicalInstitutionId?: Maybe<Scalars['String']['output']>;
  startFrom: Scalars['Date']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type OneTimeCode = {
  __typename?: 'OneTimeCode';
  code: Scalars['String']['output'];
};

export type OptionContract = {
  __typename?: 'OptionContract';
  cancelRequestedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  optionDiscount?: Maybe<OptionDiscount>;
  optionPaymentPlan: OptionPaymentPlan;
  startDate: Scalars['Date']['output'];
};

export type OptionCoupon = {
  __typename?: 'OptionCoupon';
  amountOff: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OptionDiscount = {
  __typename?: 'OptionDiscount';
  id: Scalars['ID']['output'];
  optionCoupon: OptionCoupon;
};

export type OptionPaymentPlan = {
  __typename?: 'OptionPaymentPlan';
  id: Scalars['ID']['output'];
  optionPlan: OptionPlan;
  paymentCycle: PaymentCycle;
  price: Scalars['Int']['output'];
};

export type OptionPlan = {
  __typename?: 'OptionPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderClass = {
  __typename?: 'OrderClass';
  code: OrderClassCode;
  name: Scalars['String']['output'];
};

export enum OrderClassCode {
  MedicalInstitutionClientCertificatePasswordShipping = 'MEDICAL_INSTITUTION_CLIENT_CERTIFICATE_PASSWORD_SHIPPING',
  MedicalInstitutionReplacementShipping = 'MEDICAL_INSTITUTION_REPLACEMENT_SHIPPING',
  MedicalInstitutionShipping = 'MEDICAL_INSTITUTION_SHIPPING',
  PatientReplacementShipping = 'PATIENT_REPLACEMENT_SHIPPING',
  PatientShipping = 'PATIENT_SHIPPING'
}

export enum OrderTypeEnum {
  Material = 'MATERIAL',
  None = 'NONE',
  Rental = 'RENTAL',
  WithPrescription = 'WITH_PRESCRIPTION'
}

export type PdtBillingMonthlySummariesInput = {
  billingScheduleTerm: BillingScheduleFilterTermInput;
  isSettled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PdtBillingMonthlySummary = {
  __typename?: 'PDTBillingMonthlySummary';
  amount: Scalars['Int']['output'];
  billableStatus: BillableStatus;
  billingCategory: BillingCategory;
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  numberOfPrescriptions: Scalars['Int']['output'];
  pdts: Array<Pdt>;
  senteiRyoyo: Scalars['Boolean']['output'];
  year: Scalars['Int']['output'];
};

export type Patient = {
  __typename?: 'Patient';
  birthday?: Maybe<Scalars['Date']['output']>;
  karteNumber: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriptionCodeId: Scalars['String']['output'];
  prescriptionId: Scalars['String']['output'];
  sex?: Maybe<Sex>;
};

export type PaymentCycle = {
  __typename?: 'PaymentCycle';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Pdt = {
  __typename?: 'Pdt';
  canOrderMaterial?: Maybe<Scalars['Boolean']['output']>;
  canPrintPrescription: Scalars['Boolean']['output'];
  canUseResumedStatus: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  changeableBillingStatus: Scalars['Boolean']['output'];
  closingDateOfMonth: Scalars['String']['output'];
  code: Scalars['String']['output'];
  contact?: Maybe<PdtContact>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  doctorAppApiMode?: Maybe<Scalars['String']['output']>;
  enableFlag: Scalars['Boolean']['output'];
  hasAppSiteRedirect: Scalars['Boolean']['output'];
  iconPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integratedStoreUrl?: Maybe<Scalars['String']['output']>;
  isClinicalTrial: Scalars['Boolean']['output'];
  isDiscontinued: Scalars['Boolean']['output'];
  keepBillingOnTerminateMonth: Scalars['Boolean']['output'];
  licenseRequestFormUrl?: Maybe<Scalars['String']['output']>;
  licenseRequired: Scalars['Boolean']['output'];
  medicalGuideSupported?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  needDeliveryAddressForPrescription: Scalars['Boolean']['output'];
  needOneTimeCodeForSiteUrl: Scalars['Boolean']['output'];
  /** 製品公式サイトURL */
  officialUrl?: Maybe<Scalars['String']['output']>;
  pdtDocuments: Array<PdtDocument>;
  pdtOriginalCode?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  /** @deprecated 代わりにContract.pdtSiteUrlを利用してください */
  siteUrl: Scalars['String']['output'];
  storeUrlApple: Scalars['String']['output'];
  storeUrlGoogle: Scalars['String']['output'];
  /** 製品サポートURL、HELPページへのリンク */
  supportUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  version?: Maybe<PdtVersion>;
  versions: Array<PdtVersion>;
};


export type PdtProductsArgs = {
  input?: InputMaybe<ProductFilterInput>;
};

export type PdtContact = {
  __typename?: 'PdtContact';
  businessHours?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  helpUrl?: Maybe<Scalars['String']['output']>;
  helpUrlUtm?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mailAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PdtDocument = {
  __typename?: 'PdtDocument';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isUrlS3Path: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PdtLicense = {
  __typename?: 'PdtLicense';
  contract: MemberContract;
  grantedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type PdtLicenseRequestForm = {
  __typename?: 'PdtLicenseRequestForm';
  contract: MemberContract;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum PdtType {
  Haudy = 'HAUDY',
  Ht = 'HT',
  Relivion = 'RELIVION',
  Sc = 'SC'
}

export type PdtVersion = {
  __typename?: 'PdtVersion';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  releaseDate: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type Prescription = {
  __typename?: 'Prescription';
  billingSchedules: Array<BillingSchedule>;
  birthday?: Maybe<Scalars['Date']['output']>;
  canPrint: Scalars['Boolean']['output'];
  canTransitionToCanceled: TransitionCheckResult;
  canTransitionToExtended: TransitionCheckResult;
  canTransitionToResumed: TransitionCheckResult;
  canTransitionToSenteiRyoyoReserveCanceled: TransitionCheckResult;
  canTransitionToSenteiRyoyoReservedOrStarted: TransitionCheckResult;
  canTransitionToSuspended: TransitionCheckResult;
  canTransitionToTerminated: TransitionCheckResult;
  contract: Contract;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  karteNumber: Scalars['String']['output'];
  medicalInstitution: MedicalInstitution;
  medicalInstitutionMember?: Maybe<MedicalInstitutionMember>;
  monthsFromPrescribed: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pdt: Pdt;
  prescriptionCureAppPdtCode?: Maybe<PrescriptionCureAppPdtCode>;
  prescriptionDate: Scalars['Date']['output'];
  prescriptionDeliveryOrder?: Maybe<PrescriptionDeliveryOrder>;
  prescriptionEvents?: Maybe<Array<PrescriptionEvent>>;
  senteiRyoyo?: Maybe<PrescriptionSenteiRyoyo>;
  sex?: Maybe<Sex>;
  status?: Maybe<PrescriptionStatus>;
  terminatesFrom?: Maybe<Scalars['Date']['output']>;
  unitAmount?: Maybe<UnitAmount>;
  updatedAt: Scalars['Date']['output'];
  usingNextAppPostExpiry: Scalars['Boolean']['output'];
};


export type PrescriptionBillingSchedulesArgs = {
  filter?: InputMaybe<BillingScheduleFilter>;
};

export enum PrescriptionCodeStatusLabel {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED',
  Unused = 'UNUSED',
  Used = 'USED'
}

export type PrescriptionCureAppPdtCode = {
  __typename?: 'PrescriptionCureAppPdtCode';
  activationLimit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtCodeId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<PrescriptionCodeStatusLabel>;
};

export type PrescriptionDeliveryOrder = {
  __typename?: 'PrescriptionDeliveryOrder';
  canCancel: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canRegister: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deliveryOrderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isShippingRequested?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefectureId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<DeliveryStatus>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrescriptionEvent = {
  __typename?: 'PrescriptionEvent';
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  prescriptionId: Scalars['String']['output'];
  type: PrescriptionEventType;
};

export enum PrescriptionEventType {
  CancelPrescription = 'CANCEL_PRESCRIPTION',
  CreatePrescription = 'CREATE_PRESCRIPTION',
  ExtendPrescriptionCodeExpiry = 'EXTEND_PRESCRIPTION_CODE_EXPIRY',
  ResumePrescription = 'RESUME_PRESCRIPTION',
  SenteiRyoyoReserved = 'SENTEI_RYOYO_RESERVED',
  SenteiRyoyoReserveCanceled = 'SENTEI_RYOYO_RESERVE_CANCELED',
  SenteiRyoyoStarted = 'SENTEI_RYOYO_STARTED',
  SenteiRyoyoTerminated = 'SENTEI_RYOYO_TERMINATED',
  SenteiRyoyoTerminateReserved = 'SENTEI_RYOYO_TERMINATE_RESERVED',
  SuspendPrescription = 'SUSPEND_PRESCRIPTION',
  TerminatePrescription = 'TERMINATE_PRESCRIPTION',
  UsePrescription = 'USE_PRESCRIPTION'
}

export type PrescriptionInputConfiguration = {
  __typename?: 'PrescriptionInputConfiguration';
  birthday: PrescriptionInputConfigurationType;
  note: PrescriptionInputConfigurationType;
  sex: PrescriptionInputConfigurationType;
};

export enum PrescriptionInputConfigurationItem {
  Birthday = 'BIRTHDAY',
  Fullname = 'FULLNAME',
  Note = 'NOTE',
  Sex = 'SEX'
}

/**
 * REQUIRED: 入力必須
 * OPTIONAL_VISIBLE_CREATE: 入力任意 & 新規処方画面で表示する
 * OPTIONAL_HIDDEN_CREATE: 入力任意 & 新規処方画面で表示しない (編集画面や詳細画面では表示する)
 */
export enum PrescriptionInputConfigurationType {
  OptionalHiddenCreate = 'OPTIONAL_HIDDEN_CREATE',
  OptionalVisibleCreate = 'OPTIONAL_VISIBLE_CREATE',
  Required = 'REQUIRED'
}

export type PrescriptionMedicalGuideEvent = {
  __typename?: 'PrescriptionMedicalGuideEvent';
  eventType: PrescriptionMedicalGuideEventType;
  guideOn: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['Date']['output'];
  operationLabel: Scalars['String']['output'];
};

export enum PrescriptionMedicalGuideEventType {
  ApsEvent = 'APS_EVENT',
  PdtEvent = 'PDT_EVENT',
  Resume = 'RESUME',
  Terminate = 'TERMINATE'
}

export type PrescriptionSenteiRyoyo = {
  __typename?: 'PrescriptionSenteiRyoyo';
  id: Scalars['ID']['output'];
  reserved: Scalars['Boolean']['output'];
  startDate: Scalars['Date']['output'];
};

/**
 * 通常APS向け処方ステータス。
 * キャンセル済み処方（status=CANCELED）は通常APSでは取得不可なため、この enum には含めない。
 * Admin で CANCELED を扱う場合は AdminPrescriptionStatus を使用する。
 */
export enum PrescriptionStatus {
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  SenteiRyoyoUsing = 'SENTEI_RYOYO_USING',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED',
  Unused = 'UNUSED',
  Used = 'USED'
}

export type Product = {
  __typename?: 'Product';
  availableOrderQuantities?: Maybe<Array<Scalars['Int']['output']>>;
  code: Scalars['String']['output'];
  contentPath?: Maybe<Scalars['String']['output']>;
  contentPreviewUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deliveryContract?: Maybe<DeliveryContract>;
  description: Scalars['String']['output'];
  discontinuedAt?: Maybe<Scalars['Date']['output']>;
  externalItemCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imagePath?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderType: OrderTypeEnum;
  productClass?: Maybe<ProductClass>;
  productSets?: Maybe<Array<ProductSet>>;
  receiptClass?: Maybe<ReceiptClass>;
  shippingDeadlineAdjustmentClass?: Maybe<ShippingDeadlineAdjustmentClass>;
  shippingDeadlineManagementClass?: Maybe<ShippingDeadlineManagementClass>;
  shippingDeadlineOffsetPeriod?: Maybe<Scalars['Int']['output']>;
  stockManagementClass?: Maybe<StockManagementClass>;
  unitSize?: Maybe<Scalars['Int']['output']>;
};

export type ProductClass = {
  __typename?: 'ProductClass';
  code: ProductClassCode;
};

export enum ProductClassCode {
  Set = 'SET',
  Single = 'SINGLE'
}

export type ProductFilterInput = {
  discontinued: Scalars['Boolean']['input'];
  orderType?: InputMaybe<OrderTypeEnum>;
};

export type ProductSet = {
  __typename?: 'ProductSet';
  childProduct: Product;
  product: Product;
};

export type Query = {
  __typename?: 'Query';
  deliveryOrder?: Maybe<DeliveryOrder>;
  shippingRequestFiles: Array<ShippingRequestFile>;
};


export type QueryDeliveryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingRequestFilesArgs = {
  input: ShippingRequestFilesInput;
};

export enum QueryOrderValue {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ReceiptClass = {
  __typename?: 'ReceiptClass';
  code?: Maybe<ReceiptClassCode>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ReceiptClassCode {
  Yt000 = 'YT000',
  Yt001 = 'YT001',
  Yt008 = 'YT008',
  Yt009 = 'YT009',
  Yt010 = 'YT010'
}

export type RentalDeviceBillingMonthlySummary = {
  __typename?: 'RentalDeviceBillingMonthlySummary';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  pdt: Pdt;
  year: Scalars['Int']['output'];
};

export type RentalProduct = {
  __typename?: 'RentalProduct';
  contract: Contract;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  medicalInstitution: MedicalInstitution;
  product: Product;
  rentalDate: Scalars['Date']['output'];
  returnDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ReserveOrStartSenteiRyoyoError = {
  __typename?: 'ReserveOrStartSenteiRyoyoError';
  code: SenteiRyoyoErrorCode;
  message: Scalars['String']['output'];
  senteiRyoyoPrescriptionCode?: Maybe<SenteiRyoyoPrescriptionCode>;
};

export type SenteiRyoyoContract = {
  __typename?: 'SenteiRyoyoContract';
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  restricted: Scalars['Boolean']['output'];
  startDate: Scalars['Date']['output'];
};

export enum SenteiRyoyoErrorCode {
  AlreadyReservedOrStarted = 'AlreadyReservedOrStarted',
  Restricted = 'Restricted',
  Uncontracted = 'Uncontracted',
  UnsupportedPdt = 'UnsupportedPdt',
  UnsupportedPrescriptionStatus = 'UnsupportedPrescriptionStatus'
}

export type SenteiRyoyoPrescriptionCode = {
  __typename?: 'SenteiRyoyoPrescriptionCode';
  activationLimit?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export type ShippingDeadlineAdjustmentClass = {
  __typename?: 'ShippingDeadlineAdjustmentClass';
  code: ShippingDeadlineAdjustmentClassCode;
};

export enum ShippingDeadlineAdjustmentClassCode {
  EndOfMonth = 'END_OF_MONTH',
  EndOfPreviousMonth = 'END_OF_PREVIOUS_MONTH',
  NoAdjustment = 'NO_ADJUSTMENT'
}

export type ShippingDeadlineManagementClass = {
  __typename?: 'ShippingDeadlineManagementClass';
  code: ShippingDeadlineManagementClassCode;
};

export enum ShippingDeadlineManagementClassCode {
  Managed = 'MANAGED',
  NotManaged = 'NOT_MANAGED'
}

export type ShippingRequestFile = {
  __typename?: 'ShippingRequestFile';
  createdAt: Scalars['Date']['output'];
  csvSignedURL: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ShippingRequestFilesInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order: ShippingRequestFilesOrderInput;
};

export enum ShippingRequestFilesOrderField {
  CreatedAt = 'CREATED_AT'
}

export type ShippingRequestFilesOrderInput = {
  field: ShippingRequestFilesOrderField;
  value: QueryOrderValue;
};

export type StockManagementClass = {
  __typename?: 'StockManagementClass';
  code: StockManagementClassCode;
};

export enum StockManagementClassCode {
  Managed = 'MANAGED',
  NotManaged = 'NOT_MANAGED'
}

export type TransitionCheckResult = {
  __typename?: 'TransitionCheckResult';
  isPossible: Scalars['Boolean']['output'];
  reasons?: Maybe<Array<Scalars['String']['output']>>;
};

export type UnitAmount = {
  __typename?: 'UnitAmount';
  amount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  startFrom?: Maybe<Scalars['Date']['output']>;
  type: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  medicalInstitution?: Maybe<MedicalInstitution>;
  medicalInstitutionMember?: Maybe<MedicalInstitutionMember>;
};

export type UserClientCertificate = {
  __typename?: 'UserClientCertificate';
  createdAt: Scalars['Date']['output'];
  domain: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type YearlyBillingFile = {
  __typename?: 'YearlyBillingFile';
  monthlyFiles: Array<MonthlyBillingFile>;
  year: Scalars['String']['output'];
};

export enum DeletePrescriptionRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}
